import { render } from "./AddLesson.vue?vue&type=template&id=a79c7b1a"
import script from "./AddLesson.vue?vue&type=script&lang=js"
export * from "./AddLesson.vue?vue&type=script&lang=js"
script.render = render

export default script